// src/lib/useRealKmClient.js
//
// A differenza di useKmClient() (che rispetta KM_CONFIG.MOCK_MODE ed è usato
// dai moduli già collaudati per la demo — Self-Assessment pubblico, Esperienze,
// Ricerca), questo hook punta al backend KM reale — TRANNE quando
// KM_CONFIG.HR_CONSOLE_MOCK_MODE è attivo (default true finché Daniele/Monaco
// non confermano ingestion/raccordo/fitting in ambiente test): in quel caso
// usa fixture DEV_ locali, SOLO per collaudare UI/stati/errori, non per
// collaudare la demo (indicazione esplicita di Daniele: non usare fixture
// DEMO_/dev come collaudo).
//
// Riusa il login TalentGPT esistente (Specifica v1.1, §3) quando parla con
// il backend reale: la fonte del token è sempre l'AuthContext reale.

import { useMemo } from 'react';
import { createKmClient } from '../api/client.js';
import { createMockHrConsoleClient } from '../api/mockHrConsole.js';
import { KM_CONFIG } from '../api/config.js';
import { useAuth } from '../context/AuthContext';

export function useRealKmClient() {
  const { token, logout } = useAuth();
  return useMemo(() => {
    if (KM_CONFIG.HR_CONSOLE_MOCK_MODE) return createMockHrConsoleClient();
    return createKmClient({ getAuthToken: () => token, onUnauthorized: logout });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, logout]);
}
